import React, { Component } from "react";
import { Button, List, Timeline, Typography } from "antd/lib/index";
import { connect } from "react-redux";
import { Formik } from "formik";
import { bindActionCreators } from "redux";
import SelectorComponent from "../../../../utils/SelectInputComponent";
import { odst } from "../../../../utils/schemas/odstSchema";
import { submitGroupTrivia } from "../../../../redux/actions/actividades";
import { selectCurrentUser } from "../../../../redux/selectors/auth";

class TriviaDisplay extends Component {
  render() {
    const { pregunta } = this.props;
    return (
      <React.Fragment>
        <Formik
          initialValues={{
            respuestasGrupo: [
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" },
              { values: "", label: "" }
            ]
          }}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const { groupKey, pregunta, currentUser } = this.props;

            const parsedTriv =
              values &&
              values.respuestasGrupo &&
              values.respuestasGrupo
                .map((val, i) => {
                  return {
                    respuesta: val.value,
                    numeroPregunta: i + 1,
                    respuestaCorrecta:
                      (pregunta &&
                        pregunta.preguntas[i] &&
                        pregunta.preguntas[i].respuestaCorrecta) ||
                      ""
                  };
                })
                .filter(x => !!x.respuesta);

            if (pregunta.preguntas.length === parsedTriv.length) {
              const respCorrectas = parsedTriv.filter(
                resp => resp.respuestaCorrecta === resp.respuesta
              ).length;

              this.props.submitGroupTrivia(
                groupKey,
                parsedTriv,
                currentUser,
                setStatus,
                respCorrectas,
                pregunta
              );
            } else {
              setSubmitting(false);
              setStatus({ msg: "Debes marcar todos los campos" });
            }
          }}
        >
          {props => (
            <React.Fragment>
              <List
                itemLayout="vertical"
                size="large"
                dataSource={pregunta.preguntas}
                renderItem={(item, i) => (
                  <React.Fragment>
                    <List.Item.Meta
                      avatar={<Typography.Title>{i + 1}</Typography.Title>}
                      title={item.titulo}
                      description={item.descripcion}
                    />
                    <SelectorComponent
                      {...props}
                      label="Selecciona la respuesta correcta"
                      options={odst}
                      name={`respuestasGrupo[${i}]`}
                    />
                    {props.status && props.status.finishedIcon && (
                      <Typography.Paragraph type="secondary">
                        respuesta correcta es {item.respuestaCorrecta}
                      </Typography.Paragraph>
                    )}
                  </React.Fragment>
                )}
              />

              {props.status && props.status.msg && (
                <Typography.Text type="danger">
                  {props.status.msg}
                </Typography.Text>
              )}
              {props.status && props.status.success && (
                <Typography.Text type="secondary">
                  {props.status.success}
                </Typography.Text>
              )}

              <Button
                disabled={props.isSubmitting}
                onClick={props.handleSubmit}
              >
                Hacer Submit de tu avance
              </Button>
            </React.Fragment>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ submitGroupTrivia }, dispatch);

const mapStateToProps = (state, ownProps) => {
  const viaje =
    (state.firebase.viajes.byId &&
      state.firebase.viajes.byId[ownProps.viajeId]) ||
    {};
  const currentUserId = selectCurrentUser(state).uid;
  const etapa =
    viaje.etapas &&
    viaje.etapas
      .map(etapa => {
        if (etapa.key === ownProps.etapaId) return etapa;
        return null;
      })
      .filter(x => !!x)[0];

  const actividad =
    etapa &&
    etapa.actividades &&
    etapa.actividades
      .map(actividad => {
        if (actividad.key === ownProps.actividadId) return actividad;
        return null;
      })
      .filter(x => !!x)[0];

  return {
    viaje,
    etapa,
    actividad,
    currentUserId
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TriviaDisplay);
